export default __webpack_public_path__ + "static/media/pic8.4e1fba6c.jpg";